import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';

// if (
//   window.location.origin === 'http://dev.mypart.com' &&
//   (
//     window.location.pathname === '/' ||
//     window.location.pathname === ''
//   )
// ) {
//   window.location.href = 'http://dev.mypart.com/songhunt/';
// }
//
// if (
//   window.location.origin === 'https://www.mypart.com' &&
//   (
//     window.location.pathname === '/' ||
//     window.location.pathname === ''
//   )
// ) {
//   window.location.href = 'https://www.mypart.com/songhunt/';
// }

// Bootstrap the Angular app
platformBrowserDynamic()
  .bootstrapModule(AppModule, {ngZoneEventCoalescing: true})
  .catch(err => console.error(err));
